export default __webpack_public_path__ + "static/media/1.3f4cb54c.png";